import { TableConfiguration } from "shared/components/UniversalTable/types";

/**
 * Table configuration for Renovation Documents List
 * Defines columns, filters, grouping options, and sorting for the documents table
 */
export const DOCUMENTS_TABLE_CONFIG: TableConfiguration = {
  columns: [
    {
      id: "checkbox",
      label: "",
      minWidth: 40,
      weight: 0,
    },
    {
      id: "documentNumber",
      label: "Document Nr.",
      sortKey: "documentNumber",
      minWidth: 140,
      weight: 2,
    },
    {
      id: "type",
      label: "Type",
      sortKey: "type",
      minWidth: 100,
      weight: 1,
    },
    {
      id: "supplier",
      label: "Leverancier",
      sortKey: "supplier",
      minWidth: 180,
      weight: 3,
    },
    {
      id: "documentDate",
      label: "Datum",
      sortKey: "documentDate",
      minWidth: 110,
      weight: 1,
    },
    {
      id: "status",
      label: "Status",
      sortKey: "status",
      minWidth: 120,
      weight: 2,
    },
    {
      id: "odooStatus",
      label: "In Odoo",
      minWidth: 110,
      weight: 1,
    },
    {
      id: "payment",
      label: "Betaald",
      minWidth: 110,
      weight: 1,
    },
    {
      id: "amountExclVat",
      label: "Excl. btw",
      minWidth: 110,
      weight: 2,
    },
    {
      id: "vatPercentage",
      label: "BTW %",
      minWidth: 80,
      weight: 1,
    },
    {
      id: "vatAmount",
      label: "BTW",
      minWidth: 100,
      weight: 1,
    },
    {
      id: "amount",
      label: "Bedrag incl. btw",
      sortKey: "amount",
      minWidth: 130,
      weight: 2,
    },
    {
      id: "building",
      label: "Gebouw",
      sortKey: "building",
      minWidth: 150,
      weight: 2,
    },
    {
      id: "units",
      label: "Kostenplaatsen",
      sortKey: "units",
      minWidth: 200,
      weight: 3,
    },
    {
      id: "project",
      label: "Project",
      sortKey: "project",
      minWidth: 160,
      weight: 2,
    },
    {
      id: "part",
      label: "Projectonderdeel",
      sortKey: "part",
      minWidth: 180,
      weight: 3,
    },
    {
      // Bestelbon: op een factuur de bestelbon waar ze bij hoort (klikbaar), op een
      // bestelbon hoeveel er al op gefactureerd is.
      id: "purchaseOrder",
      label: "Bestelbon",
      sortKey: "purchaseOrder",
      minWidth: 150,
      weight: 2,
    },
    {
      // Offerte: op een factuur de offerte waar ze uit volgt (klikbaar), op een
      // offerte hoeveel van het offertebedrag al gefactureerd is.
      //
      // Bewust zonder `sortKey`: de backend kent geen sortering op deze kolom, en
      // een sorteerpijl die stilzwijgend op datum sorteert is erger dan geen pijl.
      id: "quote",
      label: "Offerte",
      minWidth: 150,
      weight: 2,
    },
    {
      // Renovatieticket waaraan dit document gekoppeld is; het ticket leidt hieruit
      // zijn goedgekeurd offertebedrag en factuurbedrag af.
      id: "renoTicket",
      label: "Renovatieticket",
      sortKey: "renoTicket",
      minWidth: 130,
      weight: 2,
    },
    {
      id: "responsible",
      label: "Verantwoordelijke",
      sortKey: "responsible",
      minWidth: 200,
      weight: 3,
    },
    {
      id: "actions",
      label: "Acties",
      sortKey: undefined,
      minWidth: 80,
      weight: 1,
    },
  ],

  groupByOptions: [
    { key: "none", label: "Geen groepering" },
    { key: "type", label: "Per type" },
    { key: "status", label: "Per status" },
    { key: "project", label: "Per project" },
    { key: "supplier", label: "Per leverancier" },
  ],

  filterSections: [
    {
      key: "type",
      label: "Document Type",
      options: [
        { key: "Offerte", label: "Offerte" },
        { key: "Factuur", label: "Factuur" },
        { key: "Bestelbon", label: "Bestelbon" },
        { key: "Contract", label: "Contract" },
        { key: "Overig", label: "Overig" },
      ],
      color: "moss",
    },
    {
      key: "status",
      label: "Status",
      options: [
        { key: "Concept", label: "Concept" },
        { key: "Ontvangen", label: "Ontvangen" },
        { key: "Goedgekeurd", label: "Goedgekeurd" },
        { key: "Afgewezen", label: "Afgewezen" },
      ],
      color: "brick",
    },
  ],

  universalFilters: [
    { type: "building", label: "Gebouw", enabled: true },
    { type: "search", label: "Zoeken", enabled: true },
  ],

  enableSavedSearches: true,
};
